/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * @author  Zhuoheng Huang
 */
export default class InsertFeedback extends BaseMoserObject{

	byInsert = null;

	byRef = null;

	isAmbiguous = false;

	initialIndex = null;



	constructor(byInsert, byRef, isAmbiguous, initialIndex) {
		super();
		this.byInsert = byInsert;
		this.byRef = byRef;
		this.isAmbiguous = isAmbiguous;
		this.initialIndex = initialIndex;
	}

	getByInsert() {
		return this.byInsert;
	}

	setByInsert(byInsert) {
		this.byInsert = byInsert;
	}

	getByRef() {
		return this.byRef;
	}

	setByRef(byRef) {
		this.byRef = byRef;
	}

	getIsAmbiguous() {
		return this.isAmbiguous;
	}

	setAmbiguous(isAmbiguous) {
		this.isAmbiguous = isAmbiguous;
	}

	getInitialIndex() {
		return this.initialIndex;
	}

	setInitialIndex(initialIndex) {
		if (initialIndex == null) {
			initialIndex = 0;
		}
		this.initialIndex = initialIndex;
	}

	/**
	 * Convert <code>InsertFeedback</code> to <code>JSONObject</code>.
	 * @return {Object} <code>JSONObject</code> for <code>InsertFeedback</code> object.
	 */
	toJSON() {
		var result = {};
		if (this.byInsert) {
			var byInsert_json = [];
			for (var __i_enFor0 = 0, __exp_enFor0 = this.byInsert, __len_enFor0 = __exp_enFor0.length;
					__i_enFor0 < __len_enFor0; ++__i_enFor0) {
				var ir_byInsert = __exp_enFor0[__i_enFor0];
				byInsert_json.push(ir_byInsert.toJSON());
			}
			result["byInsert"] = byInsert_json;
		}
		if (this.byRef) {
			var byRef_json = [];
			for (var __i_enFor1 = 0, __exp_enFor1 = this.byRef, __len_enFor1 = __exp_enFor1.length;
					__i_enFor1 < __len_enFor1; ++__i_enFor1) {
				var ir_byRef = __exp_enFor1[__i_enFor1];
				byRef_json.push(ir_byRef.toJSON());
			}
			result["byRef"] = byRef_json;
		}
		result["isAmbiguous"] = this.isAmbiguous;
		result["initialIndex"] = this.initialIndex;
		return result;
	}

	//constructor() 
}


// WEBPACK FOOTER //
// ./src/generated/InsertFeedback.js